import React, { FC, memo } from 'react';
import _map from 'lodash/map';
import FormikSelectableSearchDropdown from '@minecraft.formik-selectable-search-dropdown';
import { useGenderOptions } from '../../shared/hooks';
import { FilterData } from '../../shared/types';
import { Label, StyledFormikSelectableSearchDropdown } from '../../shared/styles';

type Props = FilterData;

const Gender: FC<Props> = ({ name, label }) => {
  const genderOptions = useGenderOptions();

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelectableSearchDropdown saveAsOption name={name}>
        {_map(genderOptions, (option) => (
          <FormikSelectableSearchDropdown.Option key={option.value} label={option.label} value={option.value} />
        ))}
      </StyledFormikSelectableSearchDropdown>
    </>
  );
};

export default memo(Gender);
